<template>
  <v-card>
    <v-toolbar :tabs="tabCount > 1" flat v-if="!loadingForm">
      <v-toolbar-title v-if="model!='Platform\\Models\\Cancellation' && model!='Platform\\Models\\Redeem'">
        <span class="title-popup">
          {{ (this.readonly) ? translations.view_item : (uuid === null) ? translations.create_item : translations.edit_item }}
        </span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('data-list-events', {'closeDialog': true, 'reload': false})">
        <v-icon>close</v-icon>
      </v-btn>
      <template v-slot:extension v-if="tabCount > 1 && ! limitReached">
        <v-tabs
          slot="extension"
          v-model="selectedTab"
          :slider-color="app.color_name"
          :color="app.color_name"
          background-color="grey lighten-4"
          show-arrows
          >
          <v-tab :key="'tab_' + tab_index" :href="'#' + tab_index" v-for="(tab, tab_index) in form.items" v-if="tabCount > 1"><span class="">{{ tab.text }}</span></v-tab>

        </v-tabs>
      </template>
    </v-toolbar>


    <div v-if="loadingForm" class="px-4 py-3">
      <v-progress-linear :indeterminate="true" :color="app.color_name"></v-progress-linear>
    </div>

    <div v-if="!loadingForm && limitReached">
      <v-card-text class="pt-0">

        <p class="subtitle-1">You have reached the maximum of {{ max }} {{ translations.items_lowercase }}. If you want to create more {{ translations.items_lowercase }}, you have to upgrade your subscription.</p>

        
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn large text :color="app.color_name" :to="{'name': 'user.billing'}">Manage subscription</v-btn>
      </v-card-actions>
    </div>

    <v-form 
      data-vv-scope="formModel"
      :model="formModel" 
      v-if="!loadingForm && ! limitReached"
      @submit.prevent="submitForm('formModel')"
      autocomplete="off"
      method="post"
      id="formModel"
      accept-charset="UTF-8" 
      enctype="multipart/form-data"
      >
<!--
      <v-divider class="grey lighten-2"></v-divider>-->

      <v-card-text :style="{ 'height': settings.dialog_height + 'px' || 'auto', 'max-width': '800px', 'overflow-y': 'auto' }">
        <v-tabs-items v-model="selectedTab" :touchless="true" class="mx-2">
          <v-tab-item :value="tab_index" v-for="(tab, tab_index) in form.items" :key="tab_index" :eager="true">

            <div v-if="tab.description" v-html="tab.description" class="subtitle-1 mb-3"></div>

            <v-card v-if="Object.keys(form.items[tab_index].subs).length > 1" class="mb-3 elevation-1">
              <v-tabs
                v-if="Object.keys(form.items[tab_index].subs).length > 1"
                v-model="selectedSubTab[tab_index]"
                hide-slider
                :color="app.color_name"
                background-color="grey lighten-4"
                show-arrows
                >
                <v-tab :key="'sub_tab_' + sub_index" :href="'#' + sub_index" v-for="(sub, sub_index) in tab.subs" style="weight: 600;">{{ sub.text }}</v-tab>
              </v-tabs>
            </v-card>

              <v-tabs-items v-model="selectedSubTab[tab_index]" :touchless="true">
                <v-tab-item :value="sub_index" v-for="(sub, sub_index) in tab.subs" :key="sub_index" :eager="true">
                  <div v-if="sub.description" v-html="sub.description" class="subtitle-1 mb-3"></div>
                  <div v-for="(form_item, form_index) in sub.items">

                  <div v-if="form_item.type == 'description'">
                     <v-sheet
                        v-html="form_item.text"
                        class="pa-3 mb-3 subtitle-1 elevation-1"
                        color="grey lighten-4"
                      >
                    </v-sheet>
                  </div>

                  <div v-if="form_item.type == 'hidden'">
                    <input
                            type="hidden"
                            :value="form_item.val"
                            :id="'otherFormModel-'+form_item.column"
                    ></input>
                  </div>



                  <div v-if="form_item.type == 'text' || form_item.type == 'email'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-text-field
                            solo
                            denso
                      :type="form_item.type"
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                      :readonly="form_item.readonly"
                      class="form-control select-autocomplete tt"
                      tabindex="1"
                    ></v-text-field>
                  </div>

                  <div v-if="form_item.type == 'password'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-text-field
                      :type="formModel[form_item.column + '_show'] ? 'text' : 'password'"
                      :append-icon="formModel[form_item.column + '_show'] ? 'visibility' : 'visibility_off'"
                      @click:append="formModel[form_item.column + '_show'] = !formModel[form_item.column + '_show']"
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    ></v-text-field>
                  </div>

                  <div v-if="form_item.type == 'wysiwyg'">
                    <span class="v-text-field">
                      <span class="v-label v-label--active theme--light">{{form_item.text}}</span>
                    </span>
                    <ckeditor 
                      :editor="ClassicEditor"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :config="form_item.config"
                      maxlength="1000"
                    >
                    </ckeditor><br />
                      <div v-if="form_item.isEmail == true">
                          <v-text-field
                                  solo
                                  denso
                                  :type="email.type"
                                  ___autofocus="form_index == 0 && uuid == null"
                                  v-model="formModel[form_item.column]"
                                  :ref="form_item.column"
                                  :data-vv-name="form_item.column"
                                  :data-vv-as="form_item.text.toLowerCase()"
                                  v-validate="form_item.validate"
                                  :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                  :error-messages="errors.collect('formModel.' + form_item.column)"
                                  :prepend-inner-icon="form_item.icon"
                                  :placeholder="form_item.placeholder"
                                  :hint="form_item.hint"
                                  :persistent-hint="true"
                                  :prefix="form_item.prefix"
                                  :suffix="form_item.suffix"
                                  :readonly="form_item.readonly"
                                  class="form-control select-autocomplete tt"
                                  tabindex="1"
                          ></v-text-field>
                      </div>
                  </div>

                  <div v-if="form_item.type == 'number'" v-bind:style="form_item.style">                    
                    <label class="label-field block">
                      {{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}
                      <i v-if="form_item.tooltip" v-b-tooltip.hover.customClass="'tooltip'" v-b-tooltip.hover.html="tipMethod(form_item.tooltip)" class="fas fa-info-circle tooltip-form right-to-description"></i>
                    </label>
                    <span v-if="form_item.checkbox" v-bind:style="form_item.checkboxStyle">
                      <v-switch
                              class="elevation-0"
                              :inset="true"
                              color="#19CCA3"
                              @click="checkItem(form_item.column)"
                              v-model="formModel['checkbox'][form_item.column]"
                              :label="(formModel['checkbox'][form_item.column]) ? '' : form_item.description"
                      > </v-switch>
                      <!--<v-checkbox
                        class="mt-0 label-field"
                        v-model="formModel['checkbox'][form_item.column]"
                      ></v-checkbox>-->
                    </span>
                    <span v-if="!form_item.checkbox || (formModel['checkbox'][form_item.column])"
                          v-bind:style="form_item.inputStyle ? form_item.inputStyle : ''">
                      <v-text-field
                        v-on="(form_item.column == 'shopping_value') ? { change: getPoints } : {}"
                        :type="form_item.type"
                        ___autofocus="form_index == 0 && uuid == null"
                        v-model="formModel[form_item.column]"
                        :ref="form_item.column"
                        :data-vv-name="form_item.column"
                        :data-vv-as="form_item.text.toLowerCase()"
                        v-validate="form_item.validate"
                        :label="form_item.text"
                        :error-messages="errors.collect('formModel.' + form_item.column)"
                        :prepend-inner-icon="form_item.icon"
                        :placeholder="form_item.placeholder"
                        :hint="form_item.hint"
                        :persistent-hint="true"
                        :prefix="form_item.prefix"
                        :suffix="form_item.suffix"
                        flat solo
                        class="form-control select-autocomplete tt"
                      ></v-text-field>
                      </span>
                  </div>

                  <div v-if="form_item.type == 'currency'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-text-field
                      type="number"
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    ></v-text-field>
                  </div>

                  <div v-if="form_item.type === 'bespoke'">
                    <span v-if="form_item.category === 'customer-inactive' && formModel['category'] === 'customer-inactive'">
                      <label class="label-field">Send to customers inactive for</label>
                      <input v-model="formModel[form_item.column]" size="2" style="border: 1px black solid; text-align: center;"/>
                      <label class="label-field">days</label>
                    </span>
                    <span v-if="(form_item.category === 'expiration-first' ||  form_item.category === 'expiration-second') && formModel['category'] === form_item.category">
                      <label class="label-field">Send</label>
                      <input v-model="formModel[form_item.column]" size="2" style="border: 1px black solid; text-align: center;"/>
                      <label class="label-field">days before points expire</label>
                    </span>
                  </div>

                  <div v-if="form_item.type == 'date_range'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <date-range-picker
                            ___autofocus="form_index == 0 && uuid == null"
                            v-model="formModel[form_item.column]"
                            :ref="form_item.column"
                            :data-vv-name="form_item.column"
                            :data-vv-as="form_item.text.toLowerCase()"
                            v-validate="form_item.validate"
                            :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                            :error-messages="errors.collect('formModel.' + form_item.column)"
                            :prepend-inner-icon="form_item.icon"
                            :placeholder="form_item.placeholder"
                            :hint="form_item.hint"
                            :locale="$auth.user().locale.substring(0,2)"
                            :format="form_item.format"
                            timePickerFormat="ampm"
                            :persistent-hint="true"
                            :prefix="form_item.prefix"
                            :suffix="form_item.suffix"
                    >
                      <template slot="actions" slot-scope="{ parent }">
                        <v-btn :color="app.color_name" text @click="parent.okHandler">OK</v-btn>
                        <v-btn color="red" text @click.native="parent.clearHandler">Clear</v-btn>
                        <v-btn color="secondary" text @click.native="parent.display = false">Close</v-btn>
                      </template>
                    </date-range-picker>
                  </div>

                  <div v-if="form_item.type == 'date_time'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <date-time-picker
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"                      
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :locale="$auth.user().locale.substring(0,2)"
                      :format="form_item.format"
                      timePickerFormat="ampm"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    >
                      <template slot="actions" slot-scope="{ parent }">
                        <v-btn :color="app.color_name" text @click="parent.okHandler">OK</v-btn>
                        <v-btn color="red" text @click.native="parent.clearHandler">Clear</v-btn>
                        <v-btn color="secondary" text @click.native="parent.display = false">Close</v-btn>
                      </template>
                    </date-time-picker>
                  </div>

                    <!--<div v-if="form_item.type == 'emoji'">
                      <div class="messagessss">
                        <v-text-field
                             class="rich-editor-container"
                             ref="textarea"
                             @keypress.enter.prevent
                             @input="updateBody($event, form_item.column)"
                             v-model="formModel[form_item.column]"
                             :data-vv-name="form_item.column"
                             placeholder="Type a message..."
                        >
                        </v-text-field>
                        <div class="message-emoji">
                          <emoji-picker @emoji:picked="handleEmojiPicked($event, form_item.column)"
                                        :data="dataEmojis" />
                        </div>
                      </div>


                      <emoji-picker
                              :data="dataEmojis"
                              :value="formModel[form_item.column]"
                              :data-vv-name="form_item.column"
                              @emoji:picked="handleEmojiPicked" />
                      <vue-emoji
                            ref="emoji"
                            @input="emojii($event, form_item.column)"
                            width="400"
                            :value="formModel[form_item.column]"
                            :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                            :data-vv-name="form_item.column"
                            :data-vv-as="form_item.text.toLowerCase()"
                            v-validate="form_item.validate"
                            :prepend-inner-icon="form_item.icon"
                            :hint="form_item.hint"
                            :persistent-hint="true"
                            maxlength="25"
                            onfocus="this.value = this.value;"
                    />
                    </div>-->


                    <div v-if="form_item.type == 'textcounter'">
                      <label class="v-label v-label--active theme--light message-mobile">
                        Message<em class="text-light">(up to a 140 characters)</em>
                      </label><br />
                      <textarea
                              class="form-control"
                              v-on:keyup="countdown(form_item.column)"
                              v-model="formModel[form_item.column]"
                              style="width:100%"
                              placeholder="Type a message...">
                      </textarea>
                      <p class='text-right text-small' v-bind:class="{'text-danger': hasError }">{{remainingCount}}</p>
                    </div>



                    <div v-if="form_item.type == 'color'">

                    <color-picker
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :color="formModel[form_item.column]"
                      :mode="form_item.mode || 'hexa'"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    >
                    </color-picker>

                  </div>

                  <div v-if="form_item.type == 'slider'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-slider
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :ref="form_item.column"
                      :min="form_item.min"
                      :max="form_item.max"
                      :step="form_item.step"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    >

                      <template #append>
                        <v-text-field
                          v-model="formModel[form_item.column]"
                          class="pt-0 mt-0"
                          hide-details
                          single-line
                          type="number"
                          style="width: 60px"
                        ></v-text-field>
                      </template>

                    </v-slider>
                  </div>

                  <div v-if="form_item.type == 'boolean'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>                    
                    <v-switch
                            class="elevation-0"
                            :inset="true"
                            color="#19CCA3"
                            v-model="formModel[form_item.column]"
                            :label="(form_item.required) ? form_item.description + $t('_required_') : form_item.description"
                    > </v-switch>
                  </div>

                    <div v-if="form_item.type == 'boolean-second'" class="second-boolean" v-bind:style="form_item.style">
                      <!--
                      <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                      -->
                      <v-checkbox
                        type="checkbox"
                        ___autofocus="form_index == 0 && uuid == null"
                        v-model="formModel[form_item.column]"
                        :ref="form_item.column"
                        :data-vv-name="form_item.column"
                        :data-vv-as="form_item.text.toLowerCase()"
                        v-validate="form_item.validate"
                        :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                        :error-messages="errors.collect('formModel.' + form_item.column)"
                        :hint="form_item.hint"
                        :persistent-hint="true"
                        class="mt-0 label-field"
                      ></v-checkbox>
                      <i v-if="form_item.tooltip" v-b-tooltip.hover.customClass="'tooltip'" v-b-tooltip.hover.html="tipMethod(form_item.tooltip)" class="fas fa-info-circle tooltip-form right-to-description"></i>
                    </div>


                  <div v-if="form_item.type == 'static'">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>                    
                    <v-autocomplete
                            solo
                            dense
                            ___autofocus="form_index == 0 && uuid == null"
                            v-model="formModel[form_item.column]"
                            :ref="form_item.column"
                            :data-vv-name="form_item.column"
                            :data-vv-as="form_item.text.toLowerCase()"
                            v-validate="form_item.validate"
                            :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                            :error-messages="errors.collect('formModel.' + form_item.column)"
                            :hint="form_item.hint"
                            :persistent-hint="true"
                            :placeholder="form_item.placeholder"
                            :prepend-inner-icon="form_item.icon"
                            :items="relations[form_item.column].items"
                            :loading="formModel[form_item.column + '_loading']"
                            :prefix="form_item.prefix"
                            :suffix="form_item.suffix"
                            item-text="val"
                            item-value="pk"
                            hide-no-data
                            hide-selected
                            clearable
                            class="form-control select-autocomplete"
                    ></v-autocomplete>
                  </div>



                  <div v-if="form_item.type == 'relation' && (form_item.relation.type == 'hasOne' || form_item.relation.type == 'belongsTo' || form_item.relation.type == 'special')">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-autocomplete
                      solo
                      dense
                      v-on="(form_item.column == 'currency_id') ? { change: getPoints } : {}"
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.column]"
                      :disabled = "isCustomerDisable(form_item)"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :placeholder="form_item.placeholder"
                      :prepend-inner-icon="form_item.icon"
                      :items="relations[form_item.column].items"
                      :loading="formModel[form_item.column + '_loading']"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                      v-on:change="check(form_item)"
                      :readonly="form_item.readonly"
                      item-text="val"
                      item-value="pk"
                      hide-no-data
                      :clearable="!form_item.clearable ? true : false"
                      class="form-control select-autocomplete"
                    ></v-autocomplete>
                  </div>

                  <div id="show-alert" v-if="form_item.type == 'relation' && (form_item.relation.type == 'belongsToMany' || form_item.relation.type == 'specialMany')">
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    
                    <i v-if="form_item.tooltip" v-b-tooltip.hover.customClass="'tooltip'" v-b-tooltip.hover.html="tipMethod(form_item.tooltip)" class="fas fa-info-circle tooltip-form"></i>
                    <!--<button type="button"
                            class="btn btn-outline-light waves-effect mo-mb-2"
                            data-container="body"
                            data-toggle="popover"
                            data-placement="right"
                            data-trigger="hover"
                            data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus."
                            data-original-title=""
                            title="">
                      Popover-right
                    </button>-->                    
                    <v-autocomplete
                      solo
                      dense
                      ___autofocus="form_index == 0 && uuid == null"
                      v-model="formModel[form_item.relation.with]"
                      :disabled = "isCustomerDisable(form_item)"
                      :ref="form_item.relation.with"
                      :data-vv-name="form_item.relation.with"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.relation.with)"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :placeholder="form_item.placeholder"
                      :prepend-inner-icon="form_item.icon"
                      :items="relations[form_item.relation.with].items"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                      v-on:change="check(form_item, $event)"
                      item-text="val"
                      item-value="pk"
                      hide-no-data
                      hide-selected
                      chips
                      multiple
                      deletable-chips
                      class="form-control select-autocomplete"
                    ></v-autocomplete>
                  </div>


                  <!-- Has Many Multi -->
                  <div id="show-alert" v-if="form_item.type == 'relation' && form_item['hasmany_multi']">
                      <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                      <div v-for="(item, idx) in hasmany_multi">
                        <v-layout row v-if="hasmany_multi.length > 0 " class="terminal-id">
                          <v-flex>
                            <label class="label-field">POS Terminal ID:</label>
                            <v-text-field
                                    solo
                                    denso
                                    :type="form_item.type"
                                    v-model="item[form_item.hasmany_multi[0]['column']]"
                                    :data-vv-as="form_item.text.toLowerCase()"
                                    v-validate="form_item.validate"
                                    :label="'POS Terminal ID:'"
                                    :prefix="form_item.prefix"
                                    :suffix="form_item.suffix"
                                    :readonly="form_item.readonly"
                                    class="form-control select-autocomplete tt"
                                    tabindex="1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 class>
                            <a type="button" @click="deleteHasmany(idx, form_item.relation.with, item.name, formModel.uuid)" class="mr-1 mt-0 mb-0 v-btn v-btn--flat v-btn--icon v-btn--round theme--dark v-size--small secondary--text">
                                <span class="v-btn__content">
                                  <i data-v-ef0c45d0="" aria-hidden="true" class="v-icon notranslate material-icons theme--light" style="font-size: 16px;">delete</i>
                                </span>
                            </a>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="additional-currency-more">
                        <v-layout row>
                          Add terminal &nbsp;<a @click="addHasmanyMulti(form_item.relation.with)"> <i class="v-icon fas fa-plus-circle" style="font-size: 14px;"></i> </a>
                        </v-layout>
                      </div>
                      <template id="example-modal">
                        <!-- Modal -->
                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                hihi
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save changes</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                  </div>







                  <div id="show-alert" v-if="form_item.type == 'multi'" >
                    <label class="label-field">{{(form_item.required) ? form_item.text + $t('_required_') : form_item.text}}</label>
                    <v-container fluid grid-list-xl>
                      <!-- Adding Main Currency -->

                      <div v-if="multi.length === 0 ">
                        <v-layout row>
                          <v-flex xs3 main-currency>
                            <v-select
                                    label='Main Currency:'
                                    v-model="formModel['currencies']['values'][0]"
                                    :items='relations[form_item.relation.with].items'
                                    item-text="val"
                                    item-value="pk" />
                          </v-flex>
                          <v-flex xs3>
                            <label class="v-label theme--light size-12">Earned Points:</label>
                            <input type="text" class="input-currency" required  v-model="formModel['currencies']['points_earning'][0]" size="8" />
                          </v-flex>
                          <v-flex xs3>
                            <label class="v-label theme--light size-12">Redeem Points:</label>
                            <input type="text" class="input-currency" required  v-model="formModel['currencies']['points_earning'][0]" size="8" />
                          </v-flex>
                          <v-flex xs2>
                            <label class="v-label theme--light size-12">&nbsp;</label>
                          </v-flex>
                        </v-layout>
                      </div>

                      <div v-for="(item, idx) in multi">
                        <v-layout row v-if="multi.length === 1 || item[form_item.multi[3]['column']]">
                          <v-flex xs3>
                            <label class="v-label theme--light size-12" style="margin-bottom: 0px!important">Currency:</label>
                            <v-select
                              label='Currency:'
                              v-model="item.values"
                              :items='relations[form_item.relation.with].items'
                              item-text="val"
                              item-value="pk"
                              @change="changedValue($event, previousValue, idx)" :set="previousValue = item.values" 
                              class="form-control select-autocomplete"
                              />
                          </v-flex>
                          <v-flex xs3>
                            <label class="v-label theme--light size-12">Earned Points:</label>
                            <v-text-field
                              solo
                              denso
                              :type="form_item.type"
                              ___autofocus="form_index == 0 && uuid == null"
                              v-model="item[form_item.multi[0]['column']]"
                              :ref="form_item.column"
                              :data-vv-name="form_item.column"
                              :data-vv-as="form_item.text.toLowerCase()"
                              v-validate="form_item.validate"
                              :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                              :error-messages="errors.collect('formModel.' + form_item.column)"
                              :prepend-inner-icon="form_item.icon"
                              :placeholder="form_item.placeholder"
                              :hint="form_item.hint"
                              :persistent-hint="true"
                              :prefix="form_item.prefix"
                              :suffix="form_item.suffix"
                              :readonly="form_item.readonly"
                              class="form-control select-autocomplete tt"
                              tabindex="1"
                            ></v-text-field>

                            
                          </v-flex>
                          <v-flex xs3>
                            <label class="v-label theme--light size-12">Redeem Points:</label>
                            <v-text-field
                              solo
                              denso
                              :type="form_item.type"
                              ___autofocus="form_index == 0 && uuid == null"
                              v-model="item[form_item.multi[1]['column']]"
                              :ref="form_item.column"
                              :data-vv-name="form_item.column"
                              :data-vv-as="form_item.text.toLowerCase()"
                              v-validate="form_item.validate"
                              :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                              :error-messages="errors.collect('formModel.' + form_item.column)"
                              :prepend-inner-icon="form_item.icon"
                              :placeholder="form_item.placeholder"
                              :hint="form_item.hint"
                              :persistent-hint="true"
                              :prefix="form_item.prefix"
                              :suffix="form_item.suffix"
                              :readonly="form_item.readonly"
                              class="form-control select-autocomplete tt"
                              tabindex="1"
                            ></v-text-field>                            
                          </v-flex>
                          <v-flex xs2>
                              <label class="v-label theme--light size-12">&nbsp;</label>
                              <!--<input type="text" required  v-model="item[form_item.multi[1]['column']]" size="8" />-->
                          </v-flex>
                          <!--<v-flex xs1 class>
                            <button data-v-ef0c45d0="" type="button" @click="deleteMulti(idx, form_item.relation.with, item.values, formModel.uuid)" class="mr-1 mt-0 mb-0 v-btn v-btn&#45;&#45;flat v-btn&#45;&#45;icon v-btn&#45;&#45;round theme&#45;&#45;dark v-size&#45;&#45;small secondary&#45;&#45;text">
                                <span class="v-btn__content">
                                  <i data-v-ef0c45d0="" aria-hidden="true" class="v-icon notranslate material-icons theme&#45;&#45;light" style="font-size: 16px;">delete</i>
                                </span>
                            </button>
                          </v-flex>-->
                        </v-layout>
                      </div>

                      <!-- Adding aditional Currency -->
                      <div v-for="(item, idx) in multi">
                          <v-layout row v-if="multi.length > 1 && !item[form_item.multi[3]['column']]">
                            <v-flex xs3>
                              <label class="v-label theme--light size-12" style="margin-bottom: 0px!important">Other Currencies:</label>
                              <v-select                                      
                                      v-model="item.values"
                                      :items='relations[form_item.relation.with].items'
                                      item-text="val"
                                      item-value="pk"
                                      @change="changedValue($event, previousValue, idx)" :set="previousValue = item.values"
                                      class="form-control select-autocomplete"
                                      />
                            </v-flex>
                            <v-flex xs3>
                              <label class="v-label theme--light size-12">Earned Points:</label>
                              <v-text-field
                                solo
                                denso
                                :type="form_item.type"
                                ___autofocus="form_index == 0 && uuid == null"
                                v-model="item[form_item.multi[0]['column']]"
                                :ref="form_item.column"
                                :data-vv-name="form_item.column"
                                :data-vv-as="form_item.text.toLowerCase()"
                                v-validate="form_item.validate"
                                :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                :error-messages="errors.collect('formModel.' + form_item.column)"
                                :prepend-inner-icon="form_item.icon"
                                :placeholder="form_item.placeholder"
                                :hint="form_item.hint"
                                :persistent-hint="true"
                                :prefix="form_item.prefix"
                                :suffix="form_item.suffix"
                                :readonly="form_item.readonly"
                                class="form-control select-autocomplete tt"
                                tabindex="1"
                              ></v-text-field>                                
                            </v-flex>
                            <v-flex xs3>
                              <label class="v-label theme--light size-12">Redeem Points:</label>                              
                              <v-text-field
                                solo
                                denso
                                :type="form_item.type"
                                ___autofocus="form_index == 0 && uuid == null"
                                v-model="item[form_item.multi[1]['column']]"
                                :ref="form_item.column"
                                :data-vv-name="form_item.column"
                                :data-vv-as="form_item.text.toLowerCase()"
                                v-validate="form_item.validate"
                                :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                :error-messages="errors.collect('formModel.' + form_item.column)"
                                :prepend-inner-icon="form_item.icon"
                                :placeholder="form_item.placeholder"
                                :hint="form_item.hint"
                                :persistent-hint="true"
                                :prefix="form_item.prefix"
                                :suffix="form_item.suffix"
                                :readonly="form_item.readonly"
                                class="form-control select-autocomplete tt"
                                tabindex="1"
                              ></v-text-field>
                            </v-flex>
                              <v-flex xs2>
                                  <label class="v-label theme--light size-12">Exchange Rate:</label>                                  
                                  <v-text-field
                                    solo
                                    denso
                                    :type="form_item.type"
                                    ___autofocus="form_index == 0 && uuid == null"
                                    v-model="item[form_item.multi[2]['column']]"
                                    :ref="form_item.column"
                                    :data-vv-name="form_item.column"
                                    :data-vv-as="form_item.text.toLowerCase()"
                                    v-validate="form_item.validate"
                                    :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                    :error-messages="errors.collect('formModel.' + form_item.column)"
                                    :prepend-inner-icon="form_item.icon"
                                    :placeholder="form_item.placeholder"
                                    :hint="form_item.hint"
                                    :persistent-hint="true"
                                    :prefix="form_item.prefix"
                                    :suffix="form_item.suffix"
                                    :readonly="form_item.readonly"
                                    class="form-control select-autocomplete tt"
                                    tabindex="1"
                                  ></v-text-field>
                              </v-flex>
                            <v-flex xs1 class>
                              <button data-v-ef0c45d0="" type="button" @click="deleteMulti(idx, form_item.relation.with, item.values, formModel.uuid)" class="mr-1 mt-0 mb-0 v-btn v-btn--flat v-btn--icon v-btn--round theme--dark v-size--small secondary--text">
                                <span class="v-btn__content">
                                  <i data-v-ef0c45d0="" aria-hidden="true" class="v-icon notranslate material-icons theme--light" style="font-size: 16px;">delete</i>
                                </span>
                              </button>

                            </v-flex>
                          </v-layout>
                        </div>
                        <!--<div>
                            <input type="checkbox" v-model="moreCurrencies" @change="moreCurrenciesCheck($event)"/> Add more Currencies
                        </div>-->
                        <div class="additional-currency-more">
                            <v-layout row>
                                Add currency &nbsp;<a @click="addMulti(form_item.relation.with)"> <i class="v-icon fas fa-plus-circle" style="font-size: 14px;"></i> </a>
                            </v-layout>
                        </div>

                        <template id="example-modal">
                          <!-- Modal -->
                          <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  hihi
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                  <button type="button" class="btn btn-primary">Save changes</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>

                    </v-container>
                  </div>


                  <div v-if="form_item.type == 'image' || form_item.type == 'avatar'">
                    <v-img :src="formModel[form_item.column + '_media_url']" class="mt-3 mb-1" :class="form_item.class" contain :style="{'width': form_item.image.thumb_width, 'height': form_item.image.thumb_height, 'max-width': form_item.image.thumb_max_width, 'max-height': form_item.image.thumb_max_height}" v-if="formModel[form_item.column + '_media_url']"></v-img>
                    <v-text-field
                      @click="pickFile(form_item.column)"
                      type="text"
                      readonly
                      v-model="formModel[form_item.column + '_media_name']"
                      :ref="form_item.column"
                      :data-vv-name="form_item.column"
                      :data-vv-as="form_item.text.toLowerCase()"
                      v-validate="form_item.validate"
                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                      :error-messages="errors.collect('formModel.' + form_item.column)"
                      :prepend-inner-icon="form_item.icon"
                      :placeholder="form_item.placeholder"
                      :hint="form_item.hint"
                      :persistent-hint="true"
                      :prefix="form_item.prefix"
                      :suffix="form_item.suffix"
                    >
                      <template slot="append">
                          <v-icon v-if="formModel[form_item.column + '_media_name'] != ''" @click="formModel[form_item.column + '_media_name'] = ''; formModel[form_item.column + '_media_url'] = ''; formModel[form_item.column + '_media_changed'] = true;">delete</v-icon>
                      </template>
                    </v-text-field>

                    <input
                      type="file"
                      style="display: none"
                      :id="form_item.column"
                      :name="form_item.column"
                      accept="image/*"
                      @change="onFilePicked"
                    >
                  </div>

                </div>

              </v-tab-item>
            </v-tabs-items>

<!--              </div>-->

          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-text class="pt-0" v-if="showPoints">
        <p class="subtitle-1">You will get this number of Points: {{points}}</p>
      </v-card-text>
      <v-card-text class="pt-0" v-if="showRedeemPoints">
        <p>Points Available: {{points}}</p>
        <p>Points Redeem: {{pointsToRedeem}}</p>
        <p>Discounts: {{discount}}</p>
        <p>Total Paid: {{value - discount}}</p>
      </v-card-text>


      <v-divider v-if="settings.dialog_height" class="grey lighten-2"></v-divider>

      <v-card-actions v-if="!loadingForm">
        <v-spacer></v-spacer>
        <v-btn color="secondary" text :disabled="form.loading" large @click="$emit('data-list-events', {'closeDialog': true, 'reload': false})">
          {{ $t('close') }}
        </v-btn>
        <v-btn v-if="!this.readonly" :color="app.color_name" text _loading="form.loading" :disabled="form.loading || remainingCount < 0" large type="submit" class="ml-0">
          {{ (uuid === null) ? (model === 'redeemForm' ? $t('confirm') : $t('create')) : $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-form>
    <v-overlay :value="form.loading" v-if="!loadingForm">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
  //import '/ckeditor5/packages/ckeditor5-build-classic/build/ckeditor';

  import {min_value} from 'vee-validate/dist/rules.esm';

  export default {
    $_veeValidate: {
      validator: 'new'
    },
    data: () => {
      return {
        maxCount: 1500,
        remainingCount: 1500,
        message: '',
        hasError: false,
        ClassicEditor: window.ClassicEditor,
        tabCount: 1,
        selectedTab: 'tab1',
        moreCurrencies: false,
        selectedSubTab: {
          tab1: 'sub1',
          tab2: 'sub1',
          tab3: 'sub1',
          tab4: 'sub1',
          tab5: 'sub1',
          tab6: 'sub1',
          tab7: 'sub1',
          tab8: 'sub1',
          tab9: 'sub1',
          tab10: 'sub1',
          tab11: 'sub1',
          tab12: 'sub1'
        },
        count: null,
        max: null,
        limitReached: null,
        activeFilePickerColumn: null,
        formModel: {},
        otherFormModel: {},
        multiFormModel: [],
        loadingForm: true,
        loading: true,
        settings: [],
        form: [],
        showPoints: false,
        showRedeemPoints: false,
        translations: [],
        relations: [],
        multi: [],
        hasmany_multi: [],
        cacheParam: '{id}'
      }
    },
    watch: {
      form: function () {
        if (this.uuid) {
          const items = _.filter(_.concat(_.get(this.form.items, 'tab1.subs.sub1.items'), _.get(this.form.items, 'tab1.subs.sub2.items')), 'refresh');
          _.forEach(items, item => {
              this.check(item);
          });
        }
      }
     },
    props: {
      api: {
        default: '/app/data-form',
        required: false,
        type: String
      },
      model: {
        default: '',
        required: false,
        type: String
      },
      uuid: {
        default: null,
        required: false,
        type: String
      },
      customer_id: {
        default: null,
        required: false,
        type: Number
      },
      item: {
        default: null,
        required: false,
        type: Object
      },
      readonly:{
        default: false,
        required: false,
        type: Boolean
      }
    },
    computed: {
      app () {
        return this.$store.getters.app
      },
    },
    created() {

      this.$validator.extend('nullable', {
        validate: (value, [testProp]) => { return true;  }
      });
      this.$validator.extend('unique', {
        validate: (value, [testProp]) => { return true;  }
      });
      this.$validator.extend('not_in', {
        validate: (value, [testProp]) => { return true;  }
      });

      /*const min_val = (value, { min } = {}) => {
        return value >= min;
      };

      // The first param is called 'min', and the second is called 'max'.
      const paramNames = ['min_val'];

      this.$validator.extend('min_val', min_val, {
        paramNames //  pass it in the extend options.
      });*/


      this.$validator.extend('min_value', {
        ...min_value,
        getMessage: 'Value must be higher than 1'
      });

      /*this.$validator.extend("min_value", {
        validate(value, { min_val }) {
          return value >= min_val;
        },
        params: ["min_val"],
        getMessage: field => 'Value must be higher than 1',
      });*/


      moment.locale(this.$auth.user().locale);

    },
    beforeMount () {
      console.log(this.uuid);
      this.getDataFromApi()
        .then(data => {
          this.form = data.form
          this.tabCount = Object.keys(this.form.items).length
        })
    },
   updated() {
      if (this.formModel['content']){
        this.countdown('content');
      }
    },
    methods: {
      checkItem(item){
        if (!!this.formModel['checkbox'][item]) {
          this.formModel[item] = null;
        }
      },
      tipMethod(description) {
        // Note this is called each time the tooltip is first opened.
        return '<div class="tooltip-class">' + description + '</div>';
      },
      countdown: function(model) {
        this.remainingCount = this.maxCount - this.formModel[model].length;
        this.hasError = this.remainingCount < 0;
      },
      moreCurrenciesCheck: function(e) {
        console.log(e.target.value);
        return !this.moreCurrencies;
      },
      /*,
      updateBody(text, column) {
        this.formModel[column] = text;
      },
      handleEmojiPicked(emoji, column) {
        this.formModel[column] = `${this.formModel[column]} ${emoji}`;
        this.updateBody(this.formModel[column]);
      }*/
      /*handleEditorClick() {
        this.focusEditor();
      },
      focusEditor() {
        this.$refs.textarea.focus();
      },*/

      getPoints: function(){
        const model = this.model.split('\\')[2] || false;
        if (model!='History') {
          switch(model){
            case 'Redeem':
              this.redeemPoints();
              break;
            /*case 'Cancellation':
              this.cancelPoints();
              break;*/
          }
          return;
        }

        if (model=='History') {
          if (this.formModel['program_id'] && this.formModel['shopping_value'] > 0) {
            const settings = {headers: {'content-type': 'multipart/form-data'}}
            const params = {
              'program_id': this.formModel['program_id'],
              'currency_id': this.formModel['currency_id'],
              'shopping_value': this.formModel['shopping_value']
            }
            this.form.loading = true;
            axios.post('/app/programs/getpoints', params).then(res => {
              if (res.status === 200) {
                this.showPoints = true;
                this.formModel['points'] = this.points = res.data.points;
                this.discount = 0;
                this.form.loading = false;
              }
            });
          } else {
            this.showPoints = false;
            this.formModel['points'] = this.points = false;
          }
        }
      },
      isCustomerDisable: function(item) {
        if (this.model!='App\\Customer' || !this.uuid) return false;

        if (item.disableuuid) {
          return true;
        }

        return false;

      },
      redeemPoints: function(){
        const model = this.model.split('\\')[2] || false;
        if (model!='Redeem') return;

        if (this.formModel['program_id'] && this.formModel['shopping_value'] > 0){
          const settings = { headers: { 'content-type': 'multipart/form-data' } }
          const params = {
            'program_id': this.formModel['program_id'],
            'currency_id': this.formModel['currency_id'],
            'business_id': this.formModel['business_id'],
            'customer_id': this.customer_id,
            'location_id': this.formModel['location_id'],
            'shopping_value': this.formModel['shopping_value']
          }
          this.form.loading = true;
          axios.post('/app/programs/redeempoints', params).then(res => {
            if (res.status === 200) {
              this.showRedeemPoints = true;
              this.points = res.data.points;
              this.pointsToRedeem = res.data.pointsToRedeem;
              this.discount = res.data.discount;
              this.value = res.data.value;
              this.form.loading = false;
            }
          });

        } else {
          this.showPoints = false;
          this.formModel['points'] = this.points = false;
        }
      },
      check: function(item, event) {
        let that = this;
        let column = item.relation.type && item.relation.with && item.relation.type === "specialMany" ? item.relation.with : item.column;
        column = Array.isArray(this.formModel[column]) ? this.formModel[column][0] : this.formModel[column];
        if (item.refresh && item.refresh_relation_api && column) {
          const url = item.refresh_relation_api.replace(/\/[^\/]*$/, '/'+column);
          this.formModel[item.refresh + '_loading'] = true;
          axios.get(url).then(data => {
            that.relations[item.refresh].items = data.data.places;
            this.formModel[item.refresh + '_loading'] = false;
          });
        }
        if (item.refresh_2 && item.refresh_relation_api_2 && column) {
          const url = item.refresh_relation_api_2.replace(/\/[^\/]*$/, '/'+column);
          this.formModel[item.refresh_2 + '_loading'] = true;
          axios.get(url).then(data => {
            that.relations[item.refresh_2].items = data.data.places;
            this.formModel[item.refresh_2 + '_loading'] = false;
          });
        }
        return false;
      },
      submitForm(scope) {
        this.form.has_error = false
        this.form.loading = true

        if (this.tabCount > 1) {
          for (let i = 2; i <= this.tabCount; i++) {

          }
        }

        this.$validator.validateAll(scope).then((valid) => {
          if (valid) {
            this.saveForm()
          } else {
            // Get first error and select tab where error occurs
            let field = this.errors.items[0].field
            let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
            let subtab = (el !== null) ? el[0].$parent.$vnode.key : null
            let tab = (el !== null) ? el[0].$parent.$parent.$parent.$vnode.key : null

            if (tab !== null) this.selectedTab = tab
            if (tab !== null && subtab !== null) this.selectedSubTab[tab] = subtab

            this.form.loading = false

            return false
          }
        });
      },
      saveForm() {
        this.loading = true
        let that = this
        const model = this.model.split('\\')[2] || false;

        // Coping value to create a new row
        if (model==='Cancellation') {
          this.formModel['customer_id'] = this.item.customer_id;
          this.formModel['business_id'] = this.item.business_id;
          this.formModel['location_id'] = this.item.location_id;
          this.formModel['program_id'] = this.item.program_id;
          this.formModel['points'] = -1*this.item.points;
          this.formModel['shopping_value'] = -1*this.item.shopping_value;
          this.formModel['transaction_number'] = this.item.transaction_number;
          this.formModel['history_id'] = this.item.id;
          this.formModel['active'] = 0;
        }

        if (model==='Redeem') {
          this.formModel['points'] = -1*this.pointsToRedeem;
          this.formModel['is_redeem'] = 1;
          this.formModel['active'] = 1;
          this.formModel['add-point'] = this.value - this.discount;
        }


        if (model==='Location') {
          for (let property in that.relations) {
            if (that.relations.hasOwnProperty(property)) {
              if (that.relations[property]['isMulti'] && this.hasmany_multi.length > 0) {
                if(!this.formModel[property]) {
                  this.formModel[property] = {};
                }
                this.formModel[property]['name'] = [];
                for (let i = 0; (i < this.hasmany_multi.length); i++) {
                  this.formModel[property]['name'][i] = this.hasmany_multi[i]['name'];
                }
              }
            }
          }
        }

        if (model==='Program') {
          console.log(this.multiFormModel);
          for (let property in that.relations) {
            if (that.relations.hasOwnProperty(property)) {
              if (that.relations[property]['isMulti'] && this.multi.length > 0) {
                let programKeys = (Object.keys(this.multi[0]));

                if(!this.formModel[property]) {
                   this.formModel[property] = {};
                }
                this.formModel[property][programKeys[0]] = [];
                this.formModel[property][programKeys[1]] = [];
                this.formModel[property][programKeys[2]] = [];
                this.formModel[property]['points_render'] = [];
                this.formModel[property]['points_redeem'] = [];

                for (let i = 0; (i < this.multi.length); i++) {
                  this.formModel[property][programKeys[0]][i] = this.multi[i][programKeys[0]];
                  this.formModel[property][programKeys[1]][i] = this.multi[i][programKeys[1]];
                  this.formModel[property][programKeys[2]][i] = this.multi[i][programKeys[2]];
                  this.formModel[property]['points_render'][i] = this.multi[i]['points_render'];
                  this.formModel[property]['points_redeem'][i] = this.multi[i]['points_redeem'];


                  if (this.multi[i].is_main_currency || this.multi.length === 1) {
                    this.formModel['main_currency'] = this.multi[i][programKeys[0]];
                  }

                }
              }
            }
          }
        }

        let settings = { headers: { 'content-type': 'multipart/form-data' } }
        // Remove image urls
        let formModel = Object.assign({}, this.formModel);

        // Adding other fields which are not in the columns
        this.otherFormModel = document.querySelectorAll('[id^=otherFormModel-]');
        _.map(this.otherFormModel, itemItr => {
          if (itemItr.value==='skip') return;
          const key = itemItr.id.split('-')[1];
          if (key != 'main_currency') {
            formModel[key] = (itemItr.value == 'uuid' && key == 'customer_id') ? that.customer_id : itemItr.value;
          }
        });

        for (let field in this.formModel) {
          if (_.endsWith(field, '_media_url') || _.endsWith(field, '_media_name') || _.endsWith(field, '_media_file') || field == 'avatar') {
            formModel[field] = null;
          }
        }

        formModel['discount'] = this.discount;
        formModel['shopping_value'] = formModel['shopping_value'] - this.discount;

        let formData = new FormData(document.getElementById('formModel'));
        formData.append('locale', this.$i18n.locale)
        formData.append('model', this.model)
        formData.append('formModel', JSON.stringify(formModel))
        formData.append('uuid', this.uuid)        


        axios.post(this.api + '/save', formData, settings)
        .then(res => {
          if (res.data.status === 'success') {
            let action = (this.uuid === null) ? 'item_created' : 'item_saved'
            this.$root.$snackbar(this.$t(action))
            if (model==='Program') {
              // this.$emit('data-list-events', {'closeDialog': true, 'reload': false});
              this.$router.push({name: 'user.program'});
              return;
            }
            this.$emit('data-list-events', {'closeDialog': true, 'reload': true})
          }
        })
        .catch(err => {
          if (typeof err.response !== 'undefined') {
            if (typeof err.response.status !== 'undefined' && err.response.data.msg !== 'undefined') {
              if (err.response.status == 422) {
                this.$root.$snackbar(err.response.data.msg)
                return
              }
            }
            this.formModel.has_error = true
            this.formModel.error = err.response.data.error
            this.formModel.errors = err.response.data.errors || {}

            // Get first error and select tab where error occurs
            let field = Object.keys(this.formModel.errors)[0]
            let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
            let tab = (el !== null) ? el[0].$parent.$vnode.key : null
            if (tab !== null) this.selectedTab = tab

            for (let field in this.formModel.errors) {
              this.$validator.errors.add({
                field: 'formModel.' + field,
                msg: this.formModel.errors[field][0]
              })
            }
          }
        })
        .finally(() => {
          that.loading = false
          that.form.loading = false

        })
      },
      getDataFromApi () {
        this.loading = true
        let that = this;
        return new Promise((resolve, reject) => {
          axios.get(this.api, {
            params: {
              locale: this.$i18n.locale,
              model: this.model,
              uuid: this.uuid
            }
            })
          .then(res => {
            if (res.data.status === 'success') {
              let form = {}
              form.items = res.data.form
              form.loading = false
              form.error = ''
              form.errors = {}
              form.has_error = false
              form.success = false

              that.settings = res.data.settings
              that.formModel = {...res.data.values, 'checkbox': {
                'points_signup': res.data.values['points_signup'] ? true : false,
                'points_first_purchase': res.data.values['points_first_purchase'] ? true : false,
                'points_max_in_purchase': res.data.values['points_max_in_purchase'] ? true : false,
                'points_valid_date': res.data.values['points_valid_date'] ? true : false,
                'points_expired_months': res.data.values['points_expired_months'] ? true : false,
              }}
              that.translations = res.data.translations
              that.relations = res.data.relations
              that.count = res.data.count
              that.max = res.data.max
              that.limitReached = res.data.limitReached
              that.loading = false
              that.loadingForm = false


              // Multi relations and setitng things right to assign values
              let i = 0;
              for (let property in that.relations) {
                if (that.relations.hasOwnProperty(property)){
                  if (that.relations[property]['isMulti'] && that.formModel[that.relations[property]['with']]) {
                    if (!that.multiFormModel[that.relations[property]['with']]) {
                      that.multiFormModel[that.relations[property]['with']] = [];
                    }
                    for (let value of that.formModel[that.relations[property]['with']]['values']) {
                      that.multiFormModel[that.relations[property]['with']][i] = {};
                      that.multiFormModel[that.relations[property]['with']][i]['values']= value;

                      // This is for terminals
                      if (
                              (that.relations[property]) &&
                              (that.relations[property]['hasmany_multi']) &&
                              (that.relations[property]['hasmany_multi'][0]) &&
                              (that.relations[property]['hasmany_multi'][0]['column'])
                      ) {
                        that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['hasmany_multi'][0]['column']] =
                                that.formModel[that.relations[property]['with']][that.relations[property]['hasmany_multi'][0]['column']][i];
                      }else {
                        if (value === that.formModel['main_currency']){
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][3]['column']] = true;
                        } else {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][3]['column']] = false;
                        }
                        that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][0]['column']]=
                                that.formModel[that.relations[property]['with']][that.relations[property]['multi'][0]['column']][i];
                        that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][1]['column']]=
                                that.formModel[that.relations[property]['with']][that.relations[property]['multi'][1]['column']][i];
                        that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][2]['column']]=
                                that.formModel[that.relations[property]['with']][that.relations[property]['multi'][2]['column']][i];
                        /*if (value === that.formModel['main_currency']) {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][3]['column']] = true;
                        } else if (!_.isUndefined(that.relations[property]['multi'][3])) {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][3]['column']] = false;
                        }

                        if (!_.isUndefined(that.relations[property]['multi'][0]['column'])) {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][0]['column']] =
                                  that.formModel[that.relations[property]['with']][that.relations[property]['multi'][0]['column']][i];
                        }

                        if (!_.isUndefined(that.relations[property]['multi'][1]['column'])) {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][1]['column']] =
                                  that.formModel[that.relations[property]['with']][that.relations[property]['multi'][1]['column']][i];
                        }

                        if (!_.isUndefined(that.relations[property]['multi'][2]['column'])) {
                          that.multiFormModel[that.relations[property]['with']][i][that.relations[property]['multi'][2]['column']] =
                                  that.formModel[that.relations[property]['with']][that.relations[property]['multi'][2]['column']][i];
                        }*/
                      }


                      i++;
                    }

                    if ((that.relations[property] && that.relations[property]['hasmany_multi'])) {
                      this.settingHasmanyMulti(property);
                    }
                    if ((that.relations[property] && that.relations[property]['multi'])) {
                      this.settingMulti(property);
                    }
                  }
                }
              }

              // Dates
              for (let date of res.data.dates) {
                if (that.formModel[date] !== null) {
                  that.formModel[date] =  new Date(that.formModel[date])
                }
              }

              if (!_.isUndefined(this.multi) && this.multi.length === 0) {
                this.addMulti();
              }

              if (!_.isUndefined(this.hasmany_multi) && this.multi.length === 0) {
                this.addHasmanyMulti();
              }

              resolve({
                form
              })
            }
          })
          .catch( err =>
            console.log(err.response)
          )
          .finally(() => that.loading = false)
        })
      },
      pickFile (column) {
        this.activeFilePickerColumn = column
        document.getElementById(column).click();
      },
      onFilePicked (e) {
        const files = e.target.files
        if(files[0] !== undefined) {
          this.formModel[this.activeFilePickerColumn + '_media_name'] = files[0].name
          if(this.formModel[this.activeFilePickerColumn + '_media_name'].lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader ()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.formModel[this.activeFilePickerColumn + '_media_url'] = fr.result
            this.formModel[this.activeFilePickerColumn + '_media_file'] = files[0] // this is an image file that can be sent to server...
            this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
          })
        } else {
          this.formModel[this.activeFilePickerColumn + '_media_name'] = ''
          this.formModel[this.activeFilePickerColumn + '_media_file'] = ''
          this.formModel[this.activeFilePickerColumn + '_media_url'] = ''
          this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
        }
      },
      getRelatedData (column, relation) {
        let that = this
        axios.post(this.api + '/relation', {
          locale: this.$i18n.locale,
          model: this.model,
          uuid: this.uuid,
          relation: relation
        })
        .then(res => {
          if (res.data.status === 'success') {
            that.formModel[column + '_items'] = res.data.fields
            that.formModel[column + '_loading'] = false
          }
        })
        .catch(err => console.log(err.response.data))
      },
      addMulti(){
        this.multi.push({});
      },
      addHasmanyMulti(){
        this.hasmany_multi.push({
          name: 'new'
        });
      },
      settingMulti(property){
        this.multi = this.multiFormModel[property];
      },
      settingHasmanyMulti(property){
        this.hasmany_multi = this.multiFormModel[property];
        if (this.hasmany_multi.length === 0){
          this.addHasmanyMulti();
        }
      },
      changedValue: function(value, previousValue, index) {
        console.log(this.formModel);
        this.multiFormModel['currencies'][index]['values'] = previousValue;
        this.multi[index]['values'] = previousValue;
        this.formModel['currencies']['values'][index] = previousValue;

        if (!previousValue) {
          this.multiFormModel['currencies'][index]['values'] = value;
          this.multi[index]['values'] = value;
          this.formModel['currencies']['values'][index] = value;
          return;
        }

        //receive the value selected (return an array if is multiple)
        this.$confirm("Changing a currency will affect all purchasing historical data, made up until now, using the old currency.\n" +
                "We would strongly recommend that you talk to our technical team, before you perform this action?").then(() => {
          this.$confirm("Are you sure you want to proceed? This may cause irreversible data loss").then(() => {
            this.multiFormModel['currencies'][index]['values'] = value;
            this.multi[index]['values'] = value;
            this.formModel['currencies']['values'][index] = value;
          }, () => {
            this.multiFormModel['currencies'][index]['values'] = previousValue;
            this.multi[index]['values'] = previousValue;
            this.formModel['currencies']['values'][index] = previousValue;
          })
        }, () => {
          this.multiFormModel['currencies'][index]['values'] = previousValue;
          this.multi[index]['values'] = previousValue;
          this.formModel['currencies']['values'][index] = previousValue;
        });
      },
      deleteHasmany(index, property, terminal, uuidLocation){
        uuidLocation = uuidLocation ? uuidLocation : null;
        this.hasmany_multi.splice(index, 1);// remove selected items-object
        axios.post('/app/locationTerminal/delete', {terminal: terminal, location_uuid: uuidLocation});
      },
      deleteMulti(index, property, currency, uuidProgram){
        this.$confirm("Changing a currency will affect all purchasing historical data, made up until now, using the old currency.\n" +
                "We would strongly recommend that you talk to our technical team, before you perform this action?").then(() => {
          this.$confirm("Are you sure you want to proceed? This may cause irreversible data loss").then(() => {
            uuidProgram = uuidProgram ? uuidProgram : null;
            this.multi.splice(index, 1);// remove selected items-object
            axios.post('/app/programCurrency/delete', {currency_id: currency, program_uuid: uuidProgram});
          });
        });
      }
    }
  }
</script>
<style scoped>
</style>